// extracted by mini-css-extract-plugin
export var bubble = "_3z-0";
export var container = "_3z-3";
export var contrastBorder = "_3z-4";
export var greyOut = "_3z-2";
export var initialsWrapper = "_3z-1";
export var large = "_3z-9";
export var medium = "_3z-8";
export var mediumSmall = "_3z-7";
export var mediumSmallMedium = "_3z-c";
export var micro = "_3z-5";
export var small = "_3z-6";
export var tiny = "_3z-b";
export var xTiny = "_3z-a";